export function IconCircleHalfFill() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
      <path
        d="M12 19C15.8661 19 19 15.8661 19 12C19 8.1339 15.8661 5 12 5C12 7 12 15 12 19Z"
        fill="currentColor"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
